/**
 * motion.ts — a single source of truth for the player's motion preference.
 *
 * Honours the OS `prefers-reduced-motion` setting so screen-shake, particle bursts and big
 * cinematics soften for players who get motion sick or simply want calm. Read live so a mid-session
 * OS change is respected.
 */
let _cached: boolean | null = null;

export function reducedMotion(): boolean {
  if (_cached !== null) return _cached;
  try {
    _cached = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    _cached = false;
  }
  return _cached;
}

if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
  try {
    window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', (e) => {
      _cached = e.matches;
    });
  } catch {
    /* Safari < 14 lacks addEventListener on MediaQueryList — fine, we use the cached read */
  }
}
